import React from 'react';
import {StyleSheet, View, Text, StyleProp, ViewStyle} from 'react-native';
import Styles from '../../Styles';
import {IsConnectedProps} from 'src/types/Screen';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import Localized from 'src/constants/AppStrings';
import {getDescriber} from '../../../components/elements/descriptor/DescriptorType';

type HomeScreenTitlesProps = IsConnectedProps & {
  label: string;
  onViewAll?: () => void;
  showViewAll?: boolean;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

const HomeScreenTitles = (props: HomeScreenTitlesProps) => {
  return (
    <View style={[styles.header, props.style]}>
      <Text
        nativeID={`HomeScreenTitles_${props.label}`}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
        testID={props.testID}
        style={getDescriber().homePageTitlesScreenStyles().title}
      >
        {props.label}
      </Text>
      {props.showViewAll && (
        <AVTouchableOpacity
          onPress={props.onViewAll}
          style={styles.touchAbleStyle}
          hitSlop={Styles.HitSlop_8}
        >
          <Text
            nativeID={`HomeScreenTitles_${Localized.Labels.view_all}`}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
            style={getDescriber().homePageTitlesScreenStyles().viewAll}
          >
            {Localized.Labels.view_all}
          </Text>
          <View style={styles.textUnderline} />
        </AVTouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: Styles.Spacing.m3,
    marginLeft: Styles.Spacing.m3,
    marginRight: Styles.Heights.h2,
    marginTop: -Styles.Spacing.m1,
  },
  textUnderline: {
    borderBottomWidth: 2,
    borderBottomColor: Styles.blackBase01,
  },
  touchAbleStyle: {
    justifyContent: 'center',
  },
});
export default HomeScreenTitles;
